module.exports = __webpack_public_path__ + "assets/images/dashboard-emerald.svg?0bf8d82963ac03f55090765f41bc8cac";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/dashboard-emerald.svg
// module id = 368
// module chunks = 0